import { Typography as MuiTypography } from "@material-ui/core";
import styled from "styled-components/macro";
import { spacing } from "@material-ui/system";
import { z } from "zod";
import useQueryParams from "../../hooks/useQueryParams";
import FiltersForm from "../../components/FiltersForm";
import SeasonalMeanChartContainer from "../../components/charts/seasonalMeanChart/SeasonalMeanChartContainer";
import React from "react";
import { usePostHeight } from "../../hooks/usePostHeight";

const Section = styled.section`
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 16px;
  background: #fff;
`;
const Typography = styled(MuiTypography)(spacing);

const PARAMETER_OPTIONS = [
  { label: "Chlorophyll-a", value: "24" },
  { label: "Total Nitrogen", value: "29" },
  { label: "Total Phosphorus", value: "28" },
];

const DEFAULTS = {
  parameterid: 24,
};

const schema = z.object({
  parameterid: z.coerce.number().default(DEFAULTS.parameterid),
  controls: z.preprocess(
    (val) => val === "true" || val === true,
    z.boolean().default(false)
  ),
  height: z.preprocess(
    (val) => (typeof val === "string" ? parseInt(val, 10) : val),
    z.number().default(400)
  ),
});

export default function SeasonalMeanEmbed() {
  usePostHeight();
  const { params, setParams } = useQueryParams(schema);

  const getParameterLabel = (parameterid) => {
    const param = PARAMETER_OPTIONS.find(
      (p) => p.value === String(parameterid)
    );
    return param ? param.label : "Water Quality Parameter";
  };

  const PARAM_FILTERS = [
    {
      type: "select",
      param: "parameterid",
      label: "Parameter",
      default: String(params.parameterid),
      options: PARAMETER_OPTIONS,
    },
  ];

  return (
    <>
      <main>
        {params.controls && (
          <Section>
            <Typography variant="h5" component="h2" gutterBottom>
              Filters
            </Typography>
            <FiltersForm config={PARAM_FILTERS} onChange={setParams} />
          </Section>
        )}

        <Section>
          <Typography variant="h5" component="h2" gutterBottom>
            Seasonal Mean {getParameterLabel(params.parameterid)}
          </Typography>
          <SeasonalMeanChartContainer
            parameterid={params.parameterid}
            endYear={new Date().getFullYear()}
            height={params.height}
          />
        </Section>
      </main>
    </>
  );
}
